import { render, staticRenderFns } from "./m-article-2-column.vue?vue&type=template&id=ee1df986&scoped=true"
import script from "./m-article-2-column.vue?vue&type=script&lang=js"
export * from "./m-article-2-column.vue?vue&type=script&lang=js"
import style0 from "./m-article-2-column.vue?vue&type=style&index=0&id=ee1df986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1df986",
  null
  
)

export default component.exports